export default __webpack_public_path__ + "static/media/team.288fae3a.png";